import SectionBanner from "../../components/main/SectionBanner";
import SelectionForm from "../../components/main/SectionForm";
import SectionIntroValue from "../../components/main/SectionIntroValue";
import SectionProject from "../../components/main/SectionProject";
import SectionQuestion from "../../components/main/SectionQuestion";
import SectionReason from "../../components/main/SectionReason";
import SectionStore from "../../components/main/SectionStore";
import SectionWorkProcess from "../../components/main/SectionWorkProcess";
import SEOHead from "../../components/common/SEOHead";
import JsonLd from "../../components/common/JsonLd";

const faqs = [
  {
    key: "1",
    q: "TrioCore Solutions cung cấp những giải pháp cụ thể nào cho doanh nghiệp?",
    a: "Chúng tôi cung cấp giải pháp số toàn diện gồm 3 trụ cột chính: phát triển công nghệ như thiết kế website, web-app và hệ thống thương mại điện tử; chuyển đổi số vận hành với CRM, ERP tinh gọn và phần mềm quản lý bán hàng; cùng digital marketing tổng thể như quảng cáo đa nền tảng và SEO để tối ưu tăng trưởng doanh thu.",
  },
  {
    key: "2",
    q: "Tôi có thể sử dụng riêng lẻ từng dịch vụ hoặc kết hợp trọn gói không?",
    a: "Hoàn toàn được. Doanh nghiệp có thể triển khai từng hạng mục theo nhu cầu hiện tại như chỉ làm CRM hoặc chỉ chạy marketing. Thế mạnh của TrioCore Solutions là khả năng kết nối dữ liệu giữa website, hệ thống quản trị và các chiến dịch marketing để tối ưu chi phí và luồng vận hành.",
  },
  {
    key: "3",
    q: "Hệ thống CRM/ERP của TrioCore Solutions có dễ sử dụng và tích hợp vào quy trình cũ không?",
    a: "Có. Chúng tôi ưu tiên xây dựng giải pháp tinh gọn, bám sát quy trình thực tế của doanh nghiệp thay vì áp một mô hình cồng kềnh. Hệ thống được thiết kế để nhân sự dễ tiếp cận và có thể kết nối API với website, fanpage hoặc các nền tảng bạn đang dùng.",
  },
  {
    key: "4",
    q: "Quy trình bảo mật dữ liệu khách hàng và doanh nghiệp được TrioCore Solutions xử lý thế nào?",
    a: "Bảo mật là ưu tiên hàng đầu trong các dự án hệ thống. Chúng tôi áp dụng mã hóa dữ liệu, phân quyền truy cập theo vai trò, kiểm soát đăng nhập và cấu hình sao lưu định kỳ để giảm rủi ro và đảm bảo an toàn cho dữ liệu vận hành của doanh nghiệp.",
  },
  {
    key: "5",
    q: "TrioCore Solutions cam kết chỉ số gì khi triển khai các chiến dịch Digital Marketing?",
    a: "Chúng tôi không chỉ dừng ở các chỉ số hiển thị như lượt tiếp cận hay lượt thích. Tùy mục tiêu từng chiến dịch, TrioCore Solutions tập trung vào các chỉ số thực tế hơn như số lượng khách hàng tiềm năng, tỷ lệ chuyển đổi, chi phí trên mỗi hành động và hiệu quả sử dụng ngân sách marketing.",
  },
  {
    key: "6",
    q: "Sau khi bàn giao web, phần mềm hoặc chiến dịch, TrioCore Solutions hỗ trợ doanh nghiệp như thế nào?",
    a: "Chúng tôi đồng hành dài hạn thay vì dừng ở mốc bàn giao. Với công nghệ và phần mềm, TrioCore Solutions hỗ trợ bảo trì, sửa lỗi kỹ thuật, tối ưu hạ tầng và tư vấn nâng cấp. Với marketing, chúng tôi theo dõi dữ liệu theo tuần hoặc tháng để đề xuất tối ưu phù hợp với biến động thực tế.",
  },
];

const Home: React.FC = () => {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "TrioCore Solutions",
    "url": "https://triocoresolutions.com.vn",
    "logo": "https://triocoresolutions.com.vn/logo-triocore.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "0822041909",
      "contactType": "customer service",
      "email": "info@triocoresolutions.com",
    },
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "TrioCore Solutions",
    "url": "https://triocoresolutions.com.vn",
  };

  return (
    <div>
      <SEOHead
        title="TrioCore Solutions — Thiết kế Website & Phần mềm chuyên nghiệp"
        description="TrioCore Solutions - Đơn vị uy tín chuyên cung cấp giải pháp thiết kế website chuyên nghiệp, phần mềm quản lý doanh nghiệp và dịch vụ chuyển đổi số."
        path="/"
      />
      <JsonLd data={orgSchema} />
      <JsonLd data={websiteSchema} />
      <SectionBanner />
      <SectionIntroValue />
      <SectionStore />
      <SectionWorkProcess />
      <SectionReason />
      <SectionProject />
      <SelectionForm />
      <SectionQuestion title="Câu hỏi thường gặp tại TrioCore Solutions" faqs={faqs} />
    </div>
  );
};

export default Home;
